module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving8-5fc840eda3a7a497b2980601d0c7612c.jpg";